import { ListItemIcon, ListItemText, MenuItem } from '@mui/material'
import { useOAuth } from '@novafuturltd/core'
import { BetReceiptIcon, useBrowserQuery } from '@novafuturltd/shared'
import { getDateXDaysAgo } from '@novafuturltd/shared/helpers/getDateXDaysAgo'
import dayjs from 'dayjs'
import { useIntl } from 'react-intl'
import { ButtonLink } from '../../../../components/wrappers/Button'
import { TtoggleDrawerOnMobile } from '../../../../containers/Sidebar/Sidebar'
import { OrgIdTypeEnum } from '../../../../containers/Sidebar/trading/types'
import parseOrgId from '../../../../helpers/parseOrgId/parseOrgId'

interface MenuBetListProps {
  pathname: string
  nested?: string
  toggleDrawerOnMobile: TtoggleDrawerOnMobile
}

export const MenuBetList = ({
  pathname,
  nested,
  toggleDrawerOnMobile,
}: MenuBetListProps) => {
  const { formatMessage } = useIntl()
  const { organizationId: orgId } = useOAuth()
  const [query] = useBrowserQuery()

  const minPlacementDate = dayjs(getDateXDaysAgo(7)).format('YYYY-MM-DD')
  const maxPlacementDate = dayjs(getDateXDaysAgo(0)).format('YYYY-MM-DD')

  const placementMinMaxParam = `filter[min_placed]=${minPlacementDate}&filter[max_placed]=${maxPlacementDate}`
  const isV2Path =
    pathname.startsWith('/casino/bet-list') && query?.['api'] === 'v2'
  const isDefaultPath = pathname.startsWith('/casino/bet-list') && !isV2Path

  return (
    <div onClick={toggleDrawerOnMobile}>
      <MenuItem
        className={nested}
        component={ButtonLink}
        href={`/casino/bet-list?page=1&page_size=10&${placementMinMaxParam}`}
        selected={isDefaultPath}
      >
        <ListItemIcon>
          <BetReceiptIcon />
        </ListItemIcon>
        <ListItemText
          primary={formatMessage({
            id: 'casino.submenu.bet_list.title',
          })}
        />
      </MenuItem>
      {parseOrgId(orgId) === OrgIdTypeEnum.BET9JA && (
        <MenuItem
          className={nested}
          component={ButtonLink}
          href={`/casino/bet-list?api=v2&&page=1&page_size=10&${placementMinMaxParam}`}
          selected={isV2Path}
        >
          <ListItemIcon>
            <BetReceiptIcon />
          </ListItemIcon>
          <ListItemText
            primary={formatMessage({
              id: 'casino.submenu.bet_list.title.v1',
            })}
          />
        </MenuItem>
      )}
    </div>
  )
}
